import config from 'app-core/config';
import moment from 'moment';

import { REPEAT_TYPES, WEEK_DAYS, MONTHS } from 'app-core/constants';

function getReadableStringFromRRule(rule, opts) {
	const repeatTypes = REPEAT_TYPES.toLocale('name', config.getVueApp());
	const weekDays = WEEK_DAYS.toLocale('name', config.getVueApp());
	const months = WEEK_DAYS.toLocale('name', config.getVueApp());

	if (!rule) return config.getVueApp().$tCaption('No recurrencies', '@Scheduling');

	const v = rule.split(';').filter(f => f).reduce((res, item) =>{
		const splitted = item.split('=');
		res[splitted[0]] = isNaN(splitted[1]) ? splitted[1] : parseInt(splitted[1]);
		return res;
	} , {});

	const phrases = [];
	const repeatType = repeatTypes.find(f => f.id === v['FREQ']);
	const weekDaysString = `${v['FREQ'] === 'WEEKLY' ? ` (${config.getVueApp().$tCaption('on')} ${weekDays.filter(f => v['BYDAY'].indexOf(f.id) > -1).map(f => f.name).join(', ')})` : ''}`;

	if (v['INTERVAL'] > 1) {
		phrases.push(`${config.getVueApp().$tCaption('Every', '@Scheduling')} ${v['INTERVAL']} ${repeatType.intervalCaption}${weekDaysString}`);
	} else {
		phrases.push(`${repeatType.name}${weekDaysString}`);
	}

	if (v['BYMONTH'] || v['BYMONTHDAY']) {
		let phrase = config.getVueApp().$tCaption('on ');
		if (v['BYMONTH']) {
			phrase += months.find(f => f.id === v['BYMONTH'])?.name + ' ';
		}
		phrase += v['BYMONTHDAY'];
		phrases.push(phrase);
	}

	if (v['UNTIL'] && opts?.until !== false) {
		const date = moment(v['UNTIL']);
		phrases.push(`${config.getVueApp().$tCaption('until')} ${date.format('LLL')}`);
	}

	if (v['COUNT'] && opts?.count !== false) {
		phrases.push(`${v['COUNT']} ${config.getVueApp().$tCaption('time(s)')}`);
	}

	return phrases.filter(f => f).join(', ');
}

export {
	getReadableStringFromRRule,
	REPEAT_TYPES,
	WEEK_DAYS,
	MONTHS
}